<roots-page-header
  [toolTip]="_config.toolTip"
  [title]="_config.title"
  [loading]="_config.loading"
  [items]="actionButtons"
  (refresh)="refresh($event)"
  (actionListClicked)="topMenuActionsClicked($event)"
>
</roots-page-header>
<section class="report-query-panel">
  <div class="report-query-heading"><mat-icon>date_range</mat-icon><div><h2>Packet report date</h2><p>Select the date to query packet records.</p></div></div>
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Report date</mat-label>
    <input matInput [matDatepicker]="picker" (dateChange)="valueChanged($event)">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</section>
<roots-table
  [tableColumns]="_config.displayedColumns"
  [dataSource]="_config.dataSource"
  [filter]="_config.message"
  [csv]="_config.title"
  [items]="items"
  (actionsClicked)="actionsClicked($event)"
  [clickingEnabled]="true">
</roots-table>
